import { render, staticRenderFns } from "./home-hero-v2-item.vue?vue&type=template&id=1da5fc5e&scoped=true&"
import script from "./home-hero-v2-item.vue?vue&type=script&lang=js&"
export * from "./home-hero-v2-item.vue?vue&type=script&lang=js&"
import style0 from "./home-hero-v2-item.vue?vue&type=style&index=0&id=1da5fc5e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da5fc5e",
  null
  
)

export default component.exports